export default __webpack_public_path__ + "static/media/10.64f4e480.png";